{
    "Title": "ACD Activity Item Details",
    "SectionTitleDatetimevalues": "DATE/TIME VALUES",
    "SectionTitleDeviceandacdinfo": "DEVICE & ACD INFORMATION",
    "SectionTitleStatusvalues": "STATUS VALUES",
    "SectionTitleAssociatedtelephonyenv": "ASSOCIATED TELEPHONY ENVIRONMENT",
    "SectionTitleDiagnosticvalues": "DIAGNOSTIC VALUES",
    "ButtonHelp": "Help",
    "ButtonClose": "Close",
    "ColumnHeaderValue": "Value",
    "ColumnHeaderFieldStatistic": "Field / Statistic",
    "ButtonCollapseall": "Collapse All",
    "NAME": "ACDDNDActivity"
}